export const isNotLGSmartTV = () => {
    return typeof navigator !== 'undefined' && navigator.userAgent.includes('(Web0S; Linux/SmartTV)');
};
  